import { render, staticRenderFns } from "./agent-details.vue?vue&type=template&id=28e9eb5e&scoped=true&"
import script from "./agent-details.vue?vue&type=script&lang=js&"
export * from "./agent-details.vue?vue&type=script&lang=js&"
import style0 from "./agent-details.vue?vue&type=style&index=0&id=28e9eb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e9eb5e",
  null
  
)

export default component.exports